import { createSlice } from "@reduxjs/toolkit";
const authSlice = createSlice({
  name: "auth",
  initialState: {
    userprofiledata: "profile",
  },
  reducers: {
    adduserprofiledata(state, action) {
      state.userprofiledata = action.payload;
    },

  },
});
export const authActions = authSlice.actions;
export default authSlice;
